module.exports = __webpack_public_path__ + "static/media/home3.1186bca5.png";